import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const uploadProfilePicture = createApiThunk<string, { picture: File }>(
  "users/uploadProfilePicture",
  async ({ picture }: { picture: File }, { extra: { sharedRepository } }) => {
    return sharedRepository!.uploadProfilePicture(picture);
  },
);

export const resetUploadProfilePicture = createAction("users/resetUploadProfilePicture");
